import AuthLogic from "./AuthLogic";

export default class RouterLogic {
    static redirect(to, from, next) {
        if (AuthLogic.hasAccessToken()) {
            if (to.name === 'home') {
                next({name: 'dashboard'})
            } else {
                next()
            }

        } else {
            console.warn('Delog redirect to login')
            AuthLogic
                .logout()
                .then(() => next({
                    name: 'home',
                    query: {redirect: to.fullPath}
                }))
        }
    }
}

